import isEmail from "sane-email-validation";

export const validate = values => {
  const errors = {};
  if (!values.firstname) {
    errors.firstname = `Förnamn är obligatoriskt`;
  }
  if (!values.lastname) {
    errors.lastname = `Efternamn är obligatoriskt`;
  }
  if (values.email && values.email.length > 0) {
    if (!isEmail(values.email)) {
      errors.email = `Ogiltig E-post`;
    }
  }
  if (
    values.civicRegistrationNumber &&
    values.civicRegistrationNumber.length > 0
  ) {
    if (
      !/^(19|20)[0-9]{6}[- ]?[0-9]{4}$/.test(values.civicRegistrationNumber)
    ) {
      errors.civicRegistrationNumber = `Ogiltigt personnummer`;
    }
  }
  // if (!values.zipCode) {
  //   errors.zipCode = `Postnummer är obligatoriskt`;
  // } else if (values.zipCode.length < 5) {
  //   errors.zipCode = `Postnumret behöver vara minst 5 siffror`;
  // } else if (values.zipCode.length > 5) {
  //   errors.zipCode = `Postnumret får inte vara längre än 5 siffror`;
  // }
  return errors;
};
